import { useEffect } from "react";
import FullPageOverlay from "src/components/fullpageoverlay/FullPageOverlay";
import CloseSvg from "src/components/svg/CloseSvg";
import styles from "./SelectorWrapper.module.css";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import classNames from "classnames";

//#region [Props]
type SelectorWrapperProps = {
    children: React.ReactNode;
    onClose: () => void;
    heading?: string;
};
//#endregion

//#region [Component]
export default function SelectorWrapper({ children, onClose, heading }: SelectorWrapperProps) {
    useEffect(() => {
        const escHandler = (evt: KeyboardEvent) => {
            if (evt.code === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", escHandler, false);

        return () => {
            document.removeEventListener("keydown", escHandler, false);
        };
    }, [onClose]);

    const themeStyles = getThemeStyles(styles);

    return <FullPageOverlay hideCloseButton>
        <div className={classNames(styles.SDialogContent, themeStyles)} onClick={(e) => e.stopPropagation()}>
            <button className={styles.SCloseButton} onClick={onClose}>
                <CloseSvg />
            </button>
            {heading && <SelectorWrapperHeading heading={heading} />}
            {children}
        </div>
    </FullPageOverlay>;
}
//#endregion

type SelectorWrapperHeadingProps = {
    heading: string;
}

//#region [Component]
export function SelectorWrapperHeading({ heading }: SelectorWrapperHeadingProps) {
    return <div className={styles.SHeading}>{heading}</div>;
}
//#endregion